import React from 'react'
import {Link } from 'react-router-dom'
import { toAbsoluteUrl } from "../../../_template/helpers/CommonFunction";

// const BODY_CLASSES = ['bgi-size-cover', 'bgi-position-center', 'bgi-no-repeat']

const ErrorPage = () => {
    // useEffect(() => {
    //     BODY_CLASSES.forEach((c) => document.body.classList.add(c))
    //     document.body.style.backgroundImage = `url(${toAbsoluteUrl('media/auth/bg7.jpg')})`;
    
    //     return () => {
    //       BODY_CLASSES.forEach((c) => document.body.classList.remove(c))
    //       document.body.style.backgroundImage = 'none'
    //     }
    // }, [])

    const loginUserType = localStorage.getItem('type');

    return (
        <div className='d-flex flex-column flex-root bgi-size-cover bgi-position-center bgi-no-repeat' style={{backgroundImage:`url(${toAbsoluteUrl('media/auth/bg7.jpg')})`}}>
            <div className='d-flex flex-column flex-center flex-column-fluid'>
                <div className='d-flex flex-column flex-center text-center p-10'>
                    <div className='card card-flush  w-lg-650px py-5'>
                        <div className='card-body py-15 py-lg-20'>
                            <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Oops!</h1>
                            <div className='fw-semibold fs-6 text-gray-500 mb-7'>We can't find that page.</div>
                            <div className='mb-3'>
                                <img
                                    src={toAbsoluteUrl('media/auth/404-error.png')}
                                    className='mw-100 mh-300px theme-light-show'
                                    alt=''
                                />
                                <img
                                src={toAbsoluteUrl('media/auth/404-error-dark.png')}
                                className='mw-100 mh-300px theme-dark-show'
                                alt=''
                                />
                            </div>
                            {/* <div className='mb-0'>
                                <Link to={loginUserType === 'A' ? '/dashboard' : '/agents'} className='btn btn-sm btn-dark' >
                                    Go to home
                                </Link>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorPage;